import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";



const TokenomicsS3 = () => {
    const { t } = useTranslation();

    const priceData = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512]

    const contentHandler = () =>{
        return (
            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.title}`}>{t('Модель Ковчегов (этапная цена)')}</div>
                <div className={`${Styles.tableWrap}`}>
                    <div className={`${Styles.tableWrapTitleRow}`}>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Ковчег')}</div>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Цена')}</div>
                    </div>
                    <div className={`${Styles.tableBox}`}>
                        {priceData.map((item, index) => {
                            return (
                                <div className={`${Styles.tableBoxRow}`} key={'priceRow' + index}>
                                    <div className={`${Styles.tableBoxRowName}`}>{index + 1} {t('ковчег')} - {t('Капсула')}</div>
                                    <div className={`${Styles.tableBoxRowValue}`}><span>{'>'}</span> {`${t('Цена')} ${item}$`} <span>{'<'}</span></div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox} ${Styles.contentBoxM}`}>
                    <CustomBorder corners={{}} fill="#151729">
                        {contentHandler()}
                    </CustomBorder>
                </div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxD}`}>
                    <CustomBorder corners={{ bottomLeft: true, topRight: true }} cutSize={15} fill="#151729">
                        {contentHandler()}
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default TokenomicsS3;